var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5h-3V4c0-2.2-1.8-4-4-4S4 1.8 4 4v1H1c-.6 0-1 .4-1 1v7c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3V6c0-.6-.4-1-1-1zM6 4c0-1.1.9-2 2-2s2 .9 2 2v1H6V4zm5 7H5V8h6v3z",
    fill: "#FBFBFB"
  })));
}

export default SvgBag;